import { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { FetchAllLocations, LinkFeedFactoryLocation, AddLocationToFeedFactory, UpdateLocationInFeedFactory } from "./Reducers/items/actions";
import { message as showMessage } from "../../Reducers/loading/actions";
import BootstrapTable, { ROW_SELECT_MULTIPLE } from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const ExternePartners = ({ locations }) => {
  const dispatch = useDispatch();
  const message = (time, type, msg) => dispatch(showMessage(time, type, msg));
  const [loading, setLoading] = useState(true);
  const [syncingLocatie, setSyncingLocatie] = useState(false);
  const [syncingEvenementen, setSyncingEvenementen] = useState(false);

  useEffect(() => {
    // Set loading to false on mount
    setLoading(false);
  }, []);

  const handleSyncLocatie = async () => {
    setSyncingLocatie(true);
    try {
      // Fetch all locations from database
      const result = await dispatch(FetchAllLocations());

      if (result && Array.isArray(result)) {
        message(3000, "success", `${result.length} locaties succesvol opgehaald`);
      } else {
        message(3000, "success", "Locaties succesvol opgehaald");
      }
    } catch (error) {
      console.error("Fout bij synchroniseren locaties:", error);
      message(4000, "warning", "Er is een fout opgetreden bij het synchroniseren van locaties");
    } finally {
      setSyncingLocatie(false);
    }
  };

  const handleSyncEvenementen = async () => {
    setSyncingEvenementen(true);
    try {
      // TODO: Implement FeedFactory evenementen synchronisatie API call

      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 2000));

      message(3000, "success", "Evenementen succesvol gesynchroniseerd");
    } catch (error) {
      console.error("Fout bij synchroniseren evenementen:", error);
      message(4000, "warning", "Er is een fout opgetreden bij het synchroniseren van evenementen");
    } finally {
      setSyncingEvenementen(false);
    }
  };

  const handleKoppelen = async (row) => {
    try {
      // Haal de FeedFactory trcid op uit de match data
      const feedfactorytrcid = row.feedFactoryMatch?.feedFactoryData?.trcid;
      const trcid = row.metadata?.trcid;

      if (!feedfactorytrcid || !trcid) {
        console.warn("Geen trcid gevonden!");
        message(4000, "warning", "Geen FeedFactory trcid gevonden");
        return;
      }

      // Gebruik de Redux actie om te koppelen
      const result = await dispatch(LinkFeedFactoryLocation(trcid, feedfactorytrcid));

      if (result.success) {
        message(3000, "success", `${row.what?.title?.value || "Locatie"} succesvol gekoppeld`);

        // Herlaad de locaties om de nieuwe status te tonen

        dispatch(FetchAllLocations());
      } else {
        console.error("Koppelen mislukt:", result);
        message(4000, "warning", result.errors?.global || "Fout bij koppelen");
      }
    } catch (error) {
      console.error("Fout bij koppelen:", error);
      message(4000, "warning", "Er is een fout opgetreden bij het koppelen");
    }


  };

  const handleToevoegen = async (row) => {


    try {
      const trcid = row.metadata?.trcid;

      if (!trcid) {
        console.warn("Geen trcid gevonden!");
        message(4000, "warning", "Geen trcid gevonden");
        return;
      }

    

      // Gebruik de Redux actie om locatie toe te voegen aan FeedFactory
      const result = await dispatch(AddLocationToFeedFactory(trcid));

    

      if (result.success) {
        message(3000, "success", `${row.what?.title?.value || "Locatie"} succesvol toegevoegd aan FeedFactory`);

        dispatch(FetchAllLocations());
  
      } else {
        console.error("Toevoegen mislukt:", result);
        message(4000, "warning", result.errors?.global || "Fout bij toevoegen aan FeedFactory");
      }
    } catch (error) {
      console.error("Fout bij toevoegen aan FeedFactory:", error);
      message(4000, "warning", "Er is een fout opgetreden bij het toevoegen aan FeedFactory");
    }

    
  };

  const handleKiesLocatie = (row) => {
    // TODO: Implementeer modal om uit meerdere locaties te kiezen
  
    message(3000, "info", `${row.feedFactoryMatch?.count || 0} locaties beschikbaar`);
  };

  const handleUpdate = async (row) => {
    console.log(row);

    try {
      const trcid = row.metadata?.trcid;

      if (!trcid) {
        console.warn("Geen trcid gevonden!");
        message(4000, "warning", "Geen trcid gevonden");
        return;
      }

      if (!row.feedfactorytrcid) {
        console.warn("Locatie is niet gekoppeld met FeedFactory!");
        message(4000, "warning", "Locatie is niet gekoppeld met FeedFactory");
        return;
      }

 

      // Gebruik de Redux actie om locatie bij te werken in FeedFactory
      const result = await dispatch(UpdateLocationInFeedFactory(trcid));



      if (result.success) {
        message(3000, "success", `${row.what?.title?.value || "Locatie"} succesvol bijgewerkt in FeedFactory`);

        // Herlaad de locaties om de laatste status te tonen
      
        dispatch(FetchAllLocations());
      
      } else {
        console.error("Bijwerken mislukt:", result);
        message(4000, "warning", result.errors?.global || "Fout bij bijwerken in FeedFactory");
      }
    } catch (error) {
      console.error("Fout bij bijwerken in FeedFactory:", error);
      message(4000, "warning", "Er is een fout opgetreden bij het bijwerken in FeedFactory");
    }

 
  };

  const columns = [
    {
      dataField: "what.title.value",
      text: "Titel",
      formatter: (cellContent) => {
        return cellContent || "Geen titel";
      },
    },
    {
      dataField: "location.city",
      text: "Plaats",
      formatter: (cellContent) => cellContent || "-",
    },
    {
      dataField: "location.zipcode",
      text: "Postcode",
      formatter: (cellContent) => cellContent || "-",
    },
    {
      dataField: "feedFactoryMatch",
      text: "FeedFactory Status",
      formatter: (cellContent) => {
        if (!cellContent) {
          return <span className="badge badge-secondary">Onbekend</span>;
        }

        switch (cellContent.status) {
          case "linked":
            return (
              <span className="badge badge-primary" title={cellContent.message}>
                <i className="fa fa-link"></i> Gekoppeld
              </span>
            );
          case "exact_match":
            return (
              <span className="badge badge-success" title={cellContent.message}>
                <i className="fa fa-check-circle"></i> Match
              </span>
            );
          case "multiple_matches":
            return (
              <span className="badge badge-warning" title={cellContent.message}>
                <i className="fa fa-exclamation-triangle"></i> {cellContent.count} matches
              </span>
            );
          case "no_match":
            return (
              <span className="badge badge-danger" title={cellContent.message}>
                <i className="fa fa-times-circle"></i> Geen match
              </span>
            );
          case "no_address":
            return (
              <span className="badge badge-secondary" title={cellContent.message}>
                <i className="fa fa-info-circle"></i> Geen adres
              </span>
            );
          case "no_connection":
            return (
              <span className="badge badge-secondary" title={cellContent.message}>
                <i className="fa fa-plug"></i> Geen connectie
              </span>
            );
          case "error":
            return (
              <span className="badge badge-danger" title={cellContent.message}>
                <i className="fa fa-exclamation-circle"></i> Error
              </span>
            );
          default:
            return <span className="badge badge-secondary">-</span>;
        }
      },
      headerStyle: () => {
        return { width: "150px" };
      },
    },
    {
      dataField: "metadata.lastupdated",
      text: "Laatst bijgewerkt",
      formatter: (cellContent) => {
        if (!cellContent) return "-";
        const date = new Date(cellContent);
        return date.toLocaleDateString("nl-NL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      },
    },
    {
      text: "Acties",
      dataField: "metadata.trcid",
      formatter: (cellContent, row) => {
        const matchStatus = row.feedFactoryMatch?.status;
        const hasFeedFactoryTrcid = row.feedfactorytrcid;

        return (
          <div>
            {matchStatus === "linked" && (
              <button className="btn btn-sm btn-primary" onClick={() => handleUpdate(row)} title="Update gekoppelde locatie in FeedFactory">
                <i className="fa fa-sync"></i> Update
              </button>
            )}

            {matchStatus === "exact_match" && (
              <button className="btn btn-sm btn-success" onClick={() => handleKoppelen(row)} title="Koppelen met FeedFactory">
                <i className="fa fa-link"></i> Koppelen
              </button>
            )}

            {matchStatus === "multiple_matches" && (
              <button className="btn btn-sm btn-warning" onClick={() => handleKiesLocatie(row)} title="Kies locatie uit meerdere matches">
                <i className="fa fa-list"></i> Kies locatie
              </button>
            )}

            {/* Toon "Toevoegen" knop voor alle gevallen waar geen feedfactorytrcid is, behalve als er een exact_match of multiple_matches is */}
            {!hasFeedFactoryTrcid && matchStatus !== "exact_match" && matchStatus !== "multiple_matches" && matchStatus !== "linked" && (
              <button className="btn btn-sm btn-info" onClick={() => handleToevoegen(row)} title="Toevoegen aan FeedFactory">
                <i className="fa fa-plus"></i> Toevoegen
              </button>
            )}
          </div>
        );
      },
      headerStyle: () => {
        return { width: "150px" };
      },
    },
  ];

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Externe Partners Integratie</h3>
        <div className="box-tools pull-right">{/* Add action buttons here if needed */}</div>
      </div>
      <div className="box-body">
        {loading ? (
          <div className="text-center">
            <i className="fa fa-spinner fa-spin fa-3x"></i>
            <p>Laden...</p>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12">
              <div className="alert alert-info">
                <h4>
                  <i className="icon fa fa-info"></i> Externe Partners
                </h4>
                <p>Hier kunt u de integratie met externe partners beheren.</p>
              </div>

              {/* FeedFactory Section */}
              <div className="box box-success">
                <div className="box-header with-border">
                  <h3 className="box-title">FeedFactory</h3>
                </div>
                <div className="box-body">
                  <p>Synchroniseer locaties en evenementen met FeedFactory.</p>

                  <div className="row" style={{ marginTop: "20px" }}>
                    <div className="col-md-6">
                      <button className="btn btn-success btn-lg btn-block" onClick={handleSyncLocatie} disabled={syncingLocatie}>
                        {syncingLocatie ? (
                          <>
                            <i className="fa fa-spinner fa-spin"></i> Synchroniseren...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-map-marker"></i> Synchroniseer Locatie
                          </>
                        )}
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button className="btn btn-success btn-lg btn-block" onClick={handleSyncEvenementen} disabled={syncingEvenementen}>
                        {syncingEvenementen ? (
                          <>
                            <i className="fa fa-spinner fa-spin"></i> Synchroniseren...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-calendar"></i> Synchroniseer Evenementen
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="alert alert-info" style={{ marginTop: "20px" }}>
                    <p>
                      <strong>Let op:</strong> De synchronisatie kan enkele minuten duren afhankelijk van het aantal items.
                    </p>
                  </div>

                  {/* Locations List - shown after sync */}
                  {locations && locations.length > 0 && (
                    <div style={{ marginTop: "30px" }}>
                      <h4 className="text-success">
                        <i className="fa fa-check-circle"></i> Locaties Overzicht ({locations.length})
                      </h4>
                      <BootstrapTable wrapperClasses="table-responsive-md" keyField="metadata.trcid" data={locations} columns={columns} pagination={paginationFactory()} />
                    </div>
                  )}
                </div>
              </div>

              {/* Other Partners Section */}
              <div className="box box-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Andere Partners</h3>
                </div>
                <div className="box-body">
                  <p>Beheer andere externe partners hier.</p>
                  {/* Add other partners integration content here */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    locations: state.items.items,
  };
};

export default connect(mapStateToProps, {})(ExternePartners);
